import { routerReducer } from '@ngrx/router-store';
import { ActionReducerMap } from '@ngrx/store';
import * as fromAlbum from './album.reducer';
import * as fromArticle from './article.reducer';
import * as fromAssignments from './assignment.school.reducer';
import * as fromAttendance from './attendance.school.reducer';
import * as fromAwards from './award.school.reducer';
import * as fromChannel from './channel.reducer';
import * as fromEvent from './event.reducer';
import * as fromExams from './exam.school.reducer';
import * as fromGradeLessons from './grade-lesson.reducer';
import * as fromGrades from './grade.school.reducer';
import * as fromGroup from './group.reducer';
import * as fromAlbumImages from './image.album.reducer';
import * as fromLessons from './lesson.school.reducer';
import * as fromManagement from './management.reducer';
import * as fromMember from './member.reducer';
import * as fromSchoolMember from './member.school.reducer';
import * as fromNotice from './notice.reducer';
import * as fromPagination from './pagination.reducer';
import * as fromPodcast from './podcast.reducer';
import * as fromPrayer from './prayer.reducer';
import * as fromSession from './session.school.reducer';
import * as fromTeacher from './teacher.school.reducer';
import * as fromUser from './user.reducer';
import * as fromVideo from './video.reducer';

export const reducers: ActionReducerMap<any> = {
  groups: fromGroup.groupReducer,
  members: fromMember.memberReducer,
  prayers: fromPrayer.prayerReducer,
  events: fromEvent.eventReducer,
  user: fromUser.userReducer,
  channel: fromChannel.channelReducer,
  podcasts: fromPodcast.podcastReducer,
  videos: fromVideo.videoReducer,
  articles: fromArticle.articleReducer,
  notices: fromNotice.noticeReducer,
  albums: fromAlbum.albumReducer,
  albumImages: fromAlbumImages.albumImageReducer,
  schoolMembers: fromSchoolMember.schoolMemberReducer,
  gradeMembers: fromTeacher.teacherReducer,
  grades: fromGrades.schoolGradeReducer,
  lessons: fromLessons.schoolLessonReducer,
  gradeLessons: fromGradeLessons.gradeLessonReducer,
  sessions: fromSession.schoolSessionReducer,
  attendance: fromAttendance.schoolAttendanceReducer,
  assignments: fromAssignments.schoolAssignmentReducer,
  awards: fromAwards.schoolAwardReducer,
  exams: fromExams.schoolExamReducer,
  router: routerReducer,
  paginations: fromPagination.paginationReducer,
  management: fromManagement.managementReducer,
};

